import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Divider, MenuItem, Typography } from '@material-ui/core';
import { navigate } from '@reach/router';
import { WS_ACTION_TYPES, POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import { commands } from '../../constants/index';
import { ArrowNext } from '../index';
import styles from '../../screens/PoiList/styles';

const { selectPoiCommand } = commands;

const FavoriteRecentList = ({
  t,
  classes,
  list,
  sendMessageToSocket,
  addStopInProgressStatus,
  saveSelectedStop,
  saveSelectedPoi,
  markSinglePoi,
}) => {
  const getCloseTime = data => {
    const [time] = data;
    const { closeTime } = time;
    return closeTime;
  };

  /**
   * @method selectedPoi sends selected POI index to NaviClient.
   * Save selected POI to redux and navigate to Poi Details Screen.
   */
  const selectedPoi = (value, index) => {
    sendMessageToSocket(selectPoiCommand(index));
    if (addStopInProgressStatus) {
      saveSelectedStop(value);
    } else {
      saveSelectedPoi(value);
    }
    markSinglePoi(true);
    navigate('destinationInformation');
  };

  return (
    <React.Fragment>
      <div className={classes.scroll__wheel}>
        {list.map((locations, index) => {
          const {
            id,
            name,
            distanceValue,
            timeValue,
            poi: { open_now, openHours, marketEnabled, permanentlyClosed },
          } = locations;
          return (
            <React.Fragment>
              <MenuItem
                key={id}
                className={classes.menuItem__container}
                onClick={() => selectedPoi(locations, index)}
              >
                <div className={classes.list__container}>
                  <Typography className={classes.left__alphabet}>
                    {String.fromCharCode('A'.charCodeAt() + index)}
                  </Typography>
                  <div className={classes.center__container}>
                    <Typography className={classes.title__text}>
                      {name}
                      {marketEnabled === true ? (
                        <i className={`material-icons ${classes.mp}`}>local_mall</i>
                      ) : (
                        ''
                      )}
                    </Typography>
                    <span className={classes.display__flex}>
                      {open_now && !permanentlyClosed ? (
                        <Typography className={classes.subtitle}>
                          {t('poi-list.label.open-now')}
                        </Typography>
                      ) : null}
                      {!open_now && !permanentlyClosed ? (
                        <Typography className={classes.subtitle}>
                          {t('poi-list.label.closed')}
                        </Typography>
                      ) : null}
                      {open_now && !permanentlyClosed && openHours !== undefined ? (
                        <React.Fragment>
                          <Typography className={classes.dot}>{t('poi-list.label.dot')}</Typography>
                          <Typography className={classes.subtitle}>
                            {t('poi-list.label.closes')}&nbsp;
                          </Typography>
                          <Typography className={classes.close__hour}>
                            {getCloseTime(openHours)}
                          </Typography>
                        </React.Fragment>
                      ) : null}
                      {!open_now && permanentlyClosed ? (
                        <Typography className={classes.close__hour}>
                          {t('poi-list.label.permanently-closed')}
                        </Typography>
                      ) : null}
                    </span>
                    <span className={classes.display__flex}>
                      <Typography className={classes.subtitle}>{timeValue}</Typography>
                      {distanceValue === undefined ? (
                        ''
                      ) : (
                        <span className={classes.display__flex}>
                          <span className={classes.dot}>{t('poi-list.label.dot')}</span>
                          <Typography className={classes.subtitle}>{distanceValue}</Typography>
                        </span>
                      )}
                    </span>
                  </div>
                  <div className={classes.arrow__right}>
                    <ArrowNext />
                  </div>
                </div>
              </MenuItem>
              <Divider />
            </React.Fragment>
          );
        })}
      </div>
    </React.Fragment>
  );
};

FavoriteRecentList.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  list: PropTypes.array,
  saveSelectedPoi: PropTypes.func.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
  saveSelectedStop: PropTypes.func.isRequired,
  addStopInProgressStatus: PropTypes.bool.isRequired,
  markSinglePoi: PropTypes.func.isRequired,
};

FavoriteRecentList.defaultProps = {
  list: [],
};

const mapStateToProps = ({ poi }) => ({
  list: poi.favorite_recent_list,
});

const mapDispatchToProps = dispatch => ({
  saveSelectedPoi: payload => dispatch({ type: POI_ACTION_TYPES.POI_SELECTED.LOADING, payload }),
  saveSelectedStop: payload => dispatch({ type: POI_ACTION_TYPES.STOPS, payload }),
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
  markSinglePoi: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.SINGLE_POI, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(FavoriteRecentList)),
);
